import { useTranslation } from 'react-i18next';
import Button from '../../../components/Button';
import Modal from '../../../components/Modal/Modal';
import { formatDate } from '../../../core/helpers';
import { ReactComponent as DownloadIcon } from '../../../icons/download.svg';

interface Props {
  isModalOpened: boolean;
  closeModal: () => void;
  name?: string;
}

export default function CountryDetailsInstructionModal({
  isModalOpened,
  closeModal,
  name,
}: Props) {
  const { t } = useTranslation();
  return (
    <Modal
      isOpened={isModalOpened}
      close={closeModal}
      title={t('Payment instruction')}
      name={name}
    >
      <div className='mx-3 pt-3 pb-4 px-3'>
        <div className='fw-800 Text--20 mb-3'>
          {formatDate(new Date(2021, 11, 1), 'MMMM yyyy')}
        </div>
        <div className='row mb-3'>
          <div className='col-4'>{t('Country')}</div>
          <div className='col'>{t('PL')}</div>
        </div>
        <div className='row mb-3'>
          <div className='col-4'>{t('Period')}</div>
          <div className='col'>
            {formatDate(new Date(2021, 0, 1), 'MMMM yyyy')}
          </div>
        </div>
        <div className='row mb-3'>
          <div className='col-4'>{t('Payee')}</div>
          <div className='col multiline'>
            Drugi Urzad Skarbowy Warszawa - Srodmiescieul. Jagiellonska 1503-719
            Warszawa
          </div>
        </div>
        <div className='row mb-3'>
          <div className='col-4'>{t('Credit institution')}</div>
          <div className='col multiline'>
            Narodowy Bank Polski O/O Warszawaul. Swietokrzyska 11/2100-919
            Warszawa
          </div>
        </div>
        <div className='row mb-3'>
          <div className='col-4'>{t('IBAN')}</div>
          <div className='col '>PL64 W010 0003 2453 4800 8120 301</div>
        </div>
        <div className='row mb-3'>
          <div className='col-4'>{t('BIC')}</div>
          <div className='col '>BITAITRRENT</div>
        </div>
        <div className='row mb-3'>
          <div className='col-4'>{t('Due Date')}</div>
          <div className='col '>
            {formatDate(new Date(2022, 0, 16), 'dd.MM.yyyy')}
          </div>
        </div>
        <div className='row mb-3'>
          <div className='col-4'>{t('Purpose')}</div>
          <div className='col '>PL3123123123 for January 1,424.95PLN</div>
        </div>
        <div className='row mb-3'>
          <div className='col-4'>{t('Amount')}</div>
          <div className='col '>1,424.95 PLN</div>
        </div>
        <div className='row mb-3'>
          <div className='col-4'>{t('Credit amount')}</div>
          <div className='col '>1,424.95 PLN</div>
        </div>
        <div className='row mb-4'>
          <div className='col-4'>{t('Balance')}</div>
          <div className='col '>100.00 PLN</div>
        </div>
        <Button
          styling='outline'
          className='FilingArchiveTab__downloadbtn mb-2'
        >
          <DownloadIcon /> Download PDF
        </Button>
      </div>
    </Modal>
  );
}
